export default __webpack_public_path__ + "static/codeme-logo-c2e112654072d2736074c6a83f96be20.svg";